import React, { Component } from 'react';
import "./ArticleContent.scss"
import { fpInit } from "../../Services/Flowplayer/player"

class ArticleContent extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentWillReceiveProps(nextProps) {
        // const _new = nextProps.html;
        // let el = document.createElement('div');
        // el.innerHTML = _new;
        // var vids = el.querySelectorAll(".flp6ScriptContainer");
        // vids.forEach(element => {
        //     let vidID = element.id.replace("vid", "");
        //     fetch('https://www.ynet.co.il/3rdparty/mobile/json/video/' + vidID + '/')
        //         .then(function (response) {
        //             return response.json();
        //         })
        //         .then(function (myJson) {
        //             let _json = myJson[0];
        //             fpInit({ poster_image: _json.poster_image, desktop: _json.desktop, mobile: _json.mobile, selector: '#vid' + _json.id }, false)
        //         });
        // });
    }
    render() {
        return (
            <div className="article-content" dangerouslySetInnerHTML={{ __html: this.props.html }}></div>
        );
    }
}

export default ArticleContent;



// WEBPACK FOOTER //
// ./src/Components/Screens/ArticleContent/ArticleContent.jsx